/**
 * Finds a machine among the navigation data (whole object)
 * @param selectedMachineId
 * @param navigationData
 * @returns {undefined}
 */
export function findMachineAmongNavigationData(
  selectedMachineId,
  navigationData,
  equipmentsMode = false,
) {
  if (selectedMachineId !== null
      && selectedMachineId !== undefined
      && Array.isArray(navigationData)) {
    // In "equiments mode", we just have an array of machines in navigationData
    if (equipmentsMode) {
      return navigationData.find((machine) => machine.machine_id === selectedMachineId);
    }
    // Browsing factories
    for (let factoryIndex = 0; factoryIndex < navigationData.length; factoryIndex += 1) {
      const factory = navigationData[factoryIndex];
      // Browsing groups
      for (let groupIndex = 0; groupIndex < factory.groups.length; groupIndex += 1) {
        // Find matching machine
        const group = factory.groups[groupIndex];
        const foundMachine = group.machines
          .find((machine) => machine.machine_id === selectedMachineId);
        if (foundMachine) return foundMachine;
      }
    }
  }

  return undefined;
}

/**
 * Finds a factory among the navigation data (whole object)
 * @param selectedFactoryId
 * @param navigationData
 * @returns {undefined}
 */
export function findFactoryAmongNavigationData(selectedFactoryId, navigationData) {
  if (selectedFactoryId !== null
      && selectedFactoryId !== undefined
      && Array.isArray(navigationData)) {
    // Browsing factories
    return navigationData.find((factory) => factory.factory_id === selectedFactoryId);
  }

  return undefined;
}

/**
 * Finds a group among the navigation data (whole object)
 * @param selectedGroupId
 * @param navigationData
 * @returns {undefined}
 */
export function findGroupAmongNavigationData(selectedGroupId, navigationData) {
  if (selectedGroupId !== null
      && selectedGroupId !== undefined
      && Array.isArray(navigationData)) {
    // Browsing factories
    let foundGroup = null;
    let foundFakeGroup = null;
    for (let index = 0; index < navigationData.length; index += 1) {
      const factory = navigationData[index];

      if (Array.isArray(factory.groups)) {
        foundGroup = factory.groups.find((group) => group.group_id === selectedGroupId);
        foundFakeGroup = factory.groups.find((group) => group.group_id === 0);

        if (foundGroup) return foundGroup;
      }
    }
    if (foundFakeGroup) return foundFakeGroup;
  }
  return undefined;
}
